import { useQuery } from '@tanstack/react-query';
import { OilStoreService } from 'services/openapi';
import { OilStoreQueryKeys } from './constants';

export const useGetOilStoresQuery = (variables?: {
  page?: string;
  pageSize?: string;
  searchString?: string;
  provinceId?: string;
  districtId?: string;
  wardId?: string;
}) => {
  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery({
    queryKey: [OilStoreQueryKeys.GET_OIL_STORES, variables],
    queryFn: () =>
      OilStoreService.oilStoreControllerGetList(
        variables?.searchString,
        variables?.provinceId,
        variables?.districtId,
        variables?.wardId,
        variables?.page,
        variables?.pageSize,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  return {
    isLoading,
    error,
    data: data?.data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};

export const useGetOilStoreDetailQuery = (id: string) => {
  return useQuery({
    queryKey: [OilStoreQueryKeys.GET_OIL_STORE_DETAIL, id],
    queryFn: () => OilStoreService.oilStoreControllerGetDetail(id),
    enabled: !!id,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};
